var f = Object.defineProperty, i = Object.defineProperties;
var n = Object.getOwnPropertyDescriptors;
var t = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var m = (r, o, e) => o in r ? f(r, o, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[o] = e, w = (r, o) => {
  for (var e in o || (o = {}))
    p.call(o, e) && m(r, e, o[e]);
  if (t)
    for (var e of t(o))
      s.call(o, e) && m(r, e, o[e]);
  return r;
}, a = (r, o) => i(r, n(o));
import c, { forwardRef as l } from "react";
import E from "../lib/IconBase.mjs";
import b from "../defs/ArrowElbowDownLeft.mjs";
const d = l((r, o) => /* @__PURE__ */ c.createElement(E, a(w({ ref: o }, r), { weights: b })));
d.displayName = "ArrowElbowDownLeft";
export {
  d as ArrowElbowDownLeft
};
